import React from "react";
import CustomSwiper from "../../ui/Slider";
import SpecialistCard from "./SpecialistCard";
import Loader from "../../../common/Loader";

export default function Recommendation({ specialists, isLoading }) {
  return (
    <section className='mt-[300px]'>
      <div className='container mx-auto'>
        <div className='h-fit'>
          <h2 className='text-2xl font-bold text-end my-8 me-16'>موصى به لك</h2>
          {isLoading ? (
            <div className='flex justify-center items-center h-[27.1875rem]'>
              <Loader isFullScreen={false} />
            </div>
          ) : (
            <>
              {specialists.length ? (
                <CustomSwiper
                  freeMode={true}
                  breakpoints={{
                    0: { slidesPerView: 1 },
                    650: { slidesPerView: 2 },
                    800: { slidesPerView: 3 },
                  }}
                  isPagination={true}
                  isNavigation={true}
                >
                  {specialists.map((item, index) => (
                    <div className='mx-10' key={item.name + index}>
                      <SpecialistCard data={item} />
                    </div>
                  ))}
                </CustomSwiper>
              ) : (
                <div className='flex justify-center items-center text-custom-25 font-custom-900 h-[400px]'>
                  لا يوجد نتائج
                </div>
              )}
            </>
          )}
        </div>
      </div>
    </section>
  );
}
